import React from 'react';
import { Layout, Card, Col, Divider, Checkbox, Tag, Icon, Row, Tabs, AutoComplete, InputNumber, Table, Typography, Button, Pagination, PageHeader, Input, Radio } from 'antd';

// import Navbar from './components/Navbar';
import DataMonta from './monta.json';

import logo from './logo.png';
import logo2 from './logo2.gif';

import './components/Navbar.css';
import './App.css';

const RMKOptions = [
	{ label: 'RPL', value: 'RPL' },
	{ label: 'NCC', value: 'NCC' },
	{ label: 'KCV', value: 'KCV' },
	{ label: 'AJK', value: 'AJK' },
	{ label: 'IGS', value: 'IGS' },
	{ label: 'AP', value: 'AP' },
	{ label: 'MI', value: 'MI' },
	{ label: 'DTK', value: 'DTK' },
];

const statusOptions = [
	{ label: 'Mendaftar', value: 'Mendaftar' },
	{ label: 'Tunggu Sidang', value: 'Tunggu Sidang' },
	{ label: 'Revisi', value: 'Revisi' },
	{ label: 'OK', value: 'OK' },
	{ label: 'Ditolak', value: 'Ditolak' },
	{ label: 'Batal', value: 'Batal' },
	{ label: 'Maju Sidang', value: 'Maju Sidang' },
	{ label: 'Lulus', value: 'Lulus' },
	{ label: 'Tidak Lulus', value: 'Tidak Lulus' },
];

const statusOptions2 = [
	{ label: 'Belum Diambil', value: '0' },
	{ label: 'Sudah Diambil', value: '1' },
];

const kolomTA = [{
	title: 'No',
	dataIndex: 'key',
  }, {
	title: 'RMK',
	dataIndex: 'rmk',
	render: rmk => (
		<span>
			<Tag color={'geekblue'} key={rmk}>{rmk.toUpperCase()}</Tag>
		</span>
	  ),
  }, {
	title: 'Nama',
	dataIndex: 'nama',
  }, {
	title: 'Judul Tugas Akhir',
	dataIndex: 'judulta',
  }, {
	title: 'Status',
	dataIndex: 'status',
	render: status => (
	  <span>
		{status.map(status => {
			let color = 'lime';
			if (status === 'Mendaftar') color='lime';
			if (status === 'Tunggu Sidang') color = 'gold';
			if (status === 'Revisi') color = 'orange';
			if (status === 'OK') color = 'green';
			if (status === 'Ditolak') color = 'red';
			if (status === 'Batal') color = 'red';
			if (status === 'Maju Sidang') color = 'cyan';
			if (status === 'Lulus') color = 'geekblue';
			if (status === 'Tidak Lulus') color = 'purple';
		  return <Tag color={color} key={status}>{status}</Tag>;
		})}
	  </span>
	),
  }];

let data = [{
	key: 1,
	rmk: 'AP',
	nama: 'Ferdinand Jason Gondowijoyo',
	judulta: 'Perbandingan Kinerja Algoritma Multipoint Evaluation dan Shifting Evaluation Values sebagai Metode Penyelesaian Komputasi Faktorial Cepat dengan Studi Kasus Factorial Modulo Prime (FACTMODP) pada Sphere Online Judge',
	status: ['OK'],
	pembimbing : ['RULLY SOELAIMAN, S.Kom., M.Kom.', 'HADZIQ FABROYIR, S.Kom., Ph.D'],
	nrp : '51161000033'
  }, {
	key: 2,
	rmk: 'AP',
	nama: 'Taufiq Tirtajiwangga',
	judulta: 'Perbandingan Kinerja Algoritma Baby-step Giant-step dan Pohlig-Hellman sebagai Metode Penyelesaian Logaritma Diskrit dengan Modulus Bilangan Prima: Studi Kasus URI Online Judge 2711 Unlocking a Cell Phone',
	status: ['OK'],
	pembimbing : ['RULLY SOELAIMAN, S.Kom., M.Kom.', 'HADZIQ FABROYIR, S.Kom., Ph.D'],
	nrp : '51161000037'
  }, {
	key: 3,
	rmk: 'AP',
	nama: 'Yoshima Syah Putri',
	judulta: 'Desain dan Analisis Algoritma Inverse Median Filtering dengan Pendekatan Dynamic Programming pada Studi Kasus: SPOJ 3003 Median Filter',
	status: ['OK'],
	pembimbing : ['RULLY SOELAIMAN, S.Kom., M.Kom.', 'HADZIQ FABROYIR, S.Kom., Ph.D'],
	nrp : '51161000038'
  }, {
	key: 4,
	rmk: 'AP',
	nama: 'Michael Julian Albertus',
	judulta: 'Desain dan Analisis Algoritma Convex Hull dan Line Sweep pada Problem SPOJ 5637 ISUN1 - LL and ErBao',
	status: ['Tunggu Sidang'],
	pembimbing : ['RULLY SOELAIMAN, S.Kom., M.Kom.', 'HADZIQ FABROYIR, S.Kom., Ph.D'],
	nrp : '51161000039'
  }, {
	key: 5,
	rmk: 'AP',
	nama: 'Modista Garsia',
	judulta: 'Penerapan Struktur Data link-cut tree pada Penyelesaian Permasalahan SPOJ 32679 ADAROADS : Ada and Roads',
	status: ['OK'],
	pembimbing : ['RULLY SOELAIMAN, S.Kom., M.Kom.', 'HADZIQ FABROYIR, S.Kom., Ph.D'],
	nrp : '51161000040'
  }, {
	key: 6,
	rmk: 'AP',
	nama: 'Ivanda Zevi Amalia',
	judulta: 'Desain dan Analisis Algoritma Optimasi Linier pada Penyelesaian Permasalahan SPOJ FN16ROAD - Road Times',
	status: ['OK'],
	pembimbing : ['RULLY SOELAIMAN, S.Kom., M.Kom.', 'HADZIQ FABROYIR, S.Kom., Ph.D'],
	nrp : '51161000041'
  }, {
	key: 7,
	rmk: 'AP',
	nama: 'Nurlita Dhuha Fatmawati',
	judulta: 'Desain dan Analisis Algoritma Minimum Steiner Tree dengan Dynamic Programming pada Studi Kasus E-Olymp 1445 Road Network',
	status: ['OK'],
	pembimbing : ['RULLY SOELAIMAN, S.Kom., M.Kom.', 'HADZIQ FABROYIR, S.Kom., Ph.D'],
	nrp : '51161000042'
  }, {
	key: 8,
	rmk: 'AP',
	nama: 'Natasha Valentina Santoso',
	judulta: 'Penerapan Pemrograman Dinamis untuk Menyelesaikan Permasalahan Komputasi Geometri: Studi Kasus SPOJ 7693 Environmental Engineering',
	status: ['Tunggu Sidang'],
	pembimbing : ['RULLY SOELAIMAN, S.Kom., M.Kom.', 'HADZIQ FABROYIR, S.Kom., Ph.D'],
	nrp : '51161000043'
  }, {
	key: 9,
	rmk: 'AP',
	nama: 'Alvin Tanuwijaya',
	judulta: 'Desain dan Analisis Complete Search Algorithm dengan Optimasi Pruning Berbasis Bitwise pada Studi Kasus SPOJ HOUSEBUY: House Buying Optimizations',
	status: ['Tunggu Sidang'],
	pembimbing : ['RULLY SOELAIMAN, S.Kom., M.Kom.', 'HADZIQ FABROYIR, S.Kom., Ph.D'],
	nrp : '51161000021'
  }, {
	key: 10,
	rmk: 'AP',
	nama: 'Zahrah Ayu Afifah Febriani',
	judulta: 'Implementasi Algoritma TPSM (Topology Preserving Structural Matching) pada Pengenalan Sebagian Wajah secara Otomatis',
	status: ['Mendaftar'],
	pembimbing : ['RULLY SOELAIMAN, S.Kom., M.Kom.', 'HADZIQ FABROYIR, S.Kom., Ph.D'],
	nrp : '51161000012'
	}];
	
data = data.concat(DataMonta)

let index = 1
data.forEach((item) => {item['key'] = index; index++})

let dataToShow = data;

const dataSource= ['RULLY SOELAIMAN, S.Kom., M.Kom.', 'HADZIQ FABROYIR, S.Kom., Ph.D']

function onChange(value){
	console.log(value)
}

let params = {
	search : '',
	rmk : [],
	status : [],
	dosen : '',
	angkatan : ''
}

let paramsCleared = {
	search : '',
	rmk : [],
	status : [],
	dosen : '',
	angkatan : ''
}

class App extends React.Component {
	constructor(){
		super();
		this.state = {
			topikta : false,
			data : dataToShow,
		}
	}

	onChange(activeKey){
		if(activeKey === "2"){
			this.setState({
				topikta : true
			})
		} else {
			this.setState({
				topikta : false
			})
		}
	}

	find(){
		let dataToShow = data.filter(item => item['nama'].toLowerCase().includes(params.search.toLowerCase()) || item['judulta'].toLowerCase().includes(params.search.toLowerCase()))
		dataToShow = dataToShow.filter((item) => {
			for(let rmk in params.rmk){
				if(item.rmk === params.rmk[rmk]){
					return true
				}
			}
			if(params.rmk.length === 0){
				return true;
			}
			return false;
		})
		dataToShow = dataToShow.filter((item) => {
			for(let status in params.status){
				if(item.status[0] === params.status[status]){
					return true
				}
			}
			if(params.status.length === 0){
				return true;
			}
			return false;
		})
		dataToShow = dataToShow.filter(item => item['pembimbing'][0].toLowerCase().includes(params.dosen.toLowerCase()) || item['pembimbing'][1].toLowerCase().includes(params.dosen.toLowerCase()))		
		dataToShow = dataToShow.filter(item => item['nrp'].substr(2,2).includes(params.angkatan.toString().substr(2,2)) || item['nrp'].substr(2,2).includes(params.angkatan.toString().substr(2,2)))		
		this.setState({data: dataToShow})
	}

	onPressEnter(value){
		params.search = value
		this.find()
	}

	changeRMK(checkedValues){
		params.rmk = checkedValues
		console.log(params.rmk)
		this.find()
	}

	changeStatus(checkedValues){
		params.status = checkedValues
		this.find()
	}

	changeDosen(value){
		params.dosen = value
		this.find()
	}

	changeAngkatan(value){
		params.angkatan = 2014
		this.find()
	}

	clear(){
		window.location.reload();
	}

	render(){

		const { topikta } = this.state;
		let sidebar = '';
		if(topikta) {
			sidebar = (
				<>
				<Card style={{ width: 270, fontSize: '12px' }}>
					<Divider style={{ marginTop: "0"}} className="filterr">Cari Topik TA</Divider>
					<Input.Search
							placeholder="Cari judul atau nama"
							className="find"
							onSearch={this.onPressEnter.bind(this)}
					/>
					<Divider  className="filterr">RMK</Divider>
					<Checkbox.Group options={RMKOptions} onChange={onChange}/>
					<Divider  className="filterr">Dosen Penawar</Divider>
					<AutoComplete
						style={{ width: 220 }}
						placeholder="Dosen Penawar"
					/>
					<Divider  className="filterr">Status</Divider>
					<Checkbox.Group options={statusOptions2}/>
					<Divider></Divider>
					<div className={"hehe2"}><Button type="primary" onClick={this.clear.bind(this)}>Clear All Filter</Button></div>
				</Card>
				</>
			)
		} else {
			sidebar = (
				<>
				<Card style={{ width: 270, fontSize: '12px' }}>
					<Divider style={{ marginTop: "0"}} className="filterr">Cari Judul TA</Divider>
					<Input.Search
							placeholder="Cari judul atau nama"
							className="find"
							onSearch={this.onPressEnter.bind(this)}
					/>
					<Divider  className="filterr">RMK</Divider>
					<Checkbox.Group options={RMKOptions} onChange={this.changeRMK.bind(this)}/>
					<Divider  className="filterr">Dosen Pembimbing</Divider>
					<AutoComplete
						style={{ width: 220 }}
						placeholder="Dosen pembimbing"
						dataSource={dataSource}
						onChange={this.changeDosen.bind(this)}
					/>
					<Divider  className="filterr">Angkatan</Divider>
					<div style={{display: 'flex'}}>
						<InputNumber min={1990} max={2020} defaultValue={1990} onChange={this.changeAngkatan.bind(this)}/>
						<p style={{margin: '7px'}}> sampai </p>
						<InputNumber min={1990} max={2020} defaultValue={2020} onChange={this.changeAngkatan.bind(this)}/>
					</div>
					<Divider  className="filterr">Status</Divider>
					<Checkbox.Group options={statusOptions} onChange={this.changeStatus.bind(this)}/>
					<Divider></Divider>
					<div className={"hehe2"}><Button type="primary" onClick={this.clear.bind(this)}>Clear All Filter</Button></div>
				</Card>
				</>
			)
		}

		return (
			<div className="global">
				<PageHeader title={
					<Row style={{width:"100vw"}}>
							<Col span={18}>
								<h2 className="logo">
									<img src={logo} alt="Logo" className={"hehe3"}></img>&nbsp;&nbsp;&nbsp;&nbsp;
									<div style={{width: '60vw'}}>
										<p>monTA</p>
										<p className={"subtitle"}>Monitoring Tugas Akhir - Informatika</p>
									</div>
								</h2>
							</Col>
							<Col span={5}>
									<div className="login-logout hehe4">
											<Radio.Group value="default">
													<Radio.Button className="hehehehe kuningkan">Daftar</Radio.Button>
													<Radio.Button className="hightlight kuningkan">Masuk</Radio.Button>
											</Radio.Group>
									</div>
							</Col>
					</Row>
			}
					className="background"
			>
			</PageHeader>
				<Layout.Content className="content">
					<Row>
						<Col span={6}>
							{sidebar}
						</Col>
						<Col span={18}>
							<Tabs defaultActiveKey="1" className="tabel" onChange={this.onChange.bind(this)}>
								<Tabs.TabPane tab={<><Icon type="book" />Pencarian TA</>} key="1">
									<p className={""}> Terdapat hasil pencarian : {this.state.data.length} hasil </p>
									<Table columns={kolomTA} dataSource={this.state.data} />
								</Tabs.TabPane>
								<Tabs.TabPane tab={<><Icon type="book" />Topik TA</>} key="2">
									<p className={""}> Terdapat hasil pencarian : 3 hasil </p>
									<Card style={{ width: '100%' }}>
										<Row>
											<Col span={16} className="judul-topik-ta"><h4>Deteksi dan Prediksi Kebutuhan Web Resource pada saat Flash Crowd pada layanan berbasis awan</h4></Col>
											<Col span={8} style={{textAlign:'right'}}>
												<span>RMK : </span><Tag color={'geekblue'} key={'rmk'}>AJK</Tag>&nbsp;&nbsp;
												<span>Status : </span><Tag color={'green'} key={'status'}>Belum diambil</Tag>
											</Col>
										</Row>
										<Row>
											<Col>
												<Typography.Paragraph>
												Pada situs e-Commerce, sering terjadi flash crowd yang mengakibatkan calon customer kesulitan untuk mengakses web e-Commerce dan ujung-ujungnya adalah menurunnya kredibilitas dari situs tersebut.
	Penelitian ini membahas bagaimana strategi dalam mendeteksi dan memprediksi kebutuhan web ... 
												</Typography.Paragraph>
											</Col>
										</Row>
										<Row>
											<Col span={16}><p>Hubungi : HENNING T.C</p></Col>
											<Col span={8} style={{textAlign:'right'}}><Button type="primary">Baca selengkapnya<Icon type="right" /></Button></Col>
										</Row>
									</Card>
									<Card style={{ width: '100%' }}>
										<Row>
											<Col span={16} className="judul-topik-ta"><h4>Steganografi Teks untuk Bahasa Sunda</h4></Col>
											<Col span={8} style={{textAlign:'right'}}>
												<span>RMK : </span><Tag color={'geekblue'} key={'rmk'}>AJK</Tag>&nbsp;&nbsp;
												<span>Status : </span><Tag color={'green'} key={'status'}>Belum diambil</Tag>
											</Col>
										</Row>
										<Row>
											<Col>
												<Typography.Paragraph>
												Penyisipan Pesan Rahasia pada Teks Aksara Sunda. Metode yang sudah pernah diambil adalah menggunakan Line Shift Coding dan Feature Coding, silahkan menggunakan metode yang berbeda.
												</Typography.Paragraph>
											</Col>
										</Row>
										<Row>
											<Col span={16}><p>Hubungi : HENNING T.C</p></Col>
											<Col span={8} style={{textAlign:'right'}}><Button type="primary">Baca selengkapnya<Icon type="right" /></Button></Col>
										</Row>
									</Card>
									<Card style={{ width: '100%' }}>
										<Row>
											<Col span={16} className="judul-topik-ta"><h4>Sistem Pengaturan dan Pengawasan Lampu Penerangan Jalan Umum Menggunakan Teknologi IoT</h4></Col>
											<Col span={8} style={{textAlign:'right'}}>
												<span>RMK : </span><Tag color={'geekblue'} key={'rmk'}>AJK</Tag>&nbsp;&nbsp;
												<span>Status : </span><Tag color={'green'} key={'status'}>Belum diambil</Tag>
											</Col>
										</Row>
										<Row>
											<Col>
												<Typography.Paragraph>
												1. Lampu PJU bisa diatur (ON/OFF) secara manual melalui Smartphone dan Web<br/>2. Lampu PJU bisa diawasi statusnya menggunakan smartphone dan web<br/>3. Sistem bisa mendapatkan informasi tentang jumlah arus/daya yang digunakan PJU per waktu<br/>4.Lampu PJU bisa ON/OFF berdasarkan... 
												</Typography.Paragraph>
											</Col>
										</Row>
										<Row>
											<Col span={16}><p>Hubungi : MUCHAMMAD HUSNI</p></Col>
											<Col span={8} style={{textAlign:'right'}}><Button type="primary">Baca selengkapnya<Icon type="right" /></Button></Col>
										</Row>
									</Card>
									<Row>
										<Col span={16}>
										</Col>
										<Col span={8} style={{textAlign:'right'}}>
											<Pagination defaultCurrent={1} total={1} />
										</Col>
									</Row>
								</Tabs.TabPane>
							</Tabs>
							
						</Col>
					</Row>
					
				</Layout.Content>
				<Layout.Footer className={"footer"}>
					<Row className={"wrapper-footer"}>
						<Col span={4}>
							<img src={logo2} alt="Logo" className={"hehe3"}></img>
						</Col>
						<Col span={10}>
							Jl. Teknik Kimia - Gedung Informatika<br/>
							Kampus Institut Teknologi Sepuluh Nopember Surabaya<br/>
							Jalan Raya ITS, Sukolilo, Surabaya 60111, Indonesia<br/>
							Telp : +62-31-5939212, 5995581, 5994251 (ext 1445, 1446) <br/>
							Fax : +62-31-5913804<br/>
							email : informatika@its.ac.id
						</Col>
						<Col span={4}>
							<div class="footer-top-content border-left-white">
								<div class="title-footer padding-left-35 text-center">
									Find us
								</div>
								<ul class="sosmed" style={{paddingBottom : '58px'}}>
									<li>
										<a href="https://www.instagram.com/dept_informatika_ftik_its/" target="_blank">
											<img src="https://www.its.ac.id/informatika/wp-content/themes/DepartmentITS/assets/img/icons/logo-instagram.png"/>
										</a>
									</li>
																							<li>
										<a href="https://www.facebook.com/groups/pusinfotc/" target="_blank">
											<img src="https://www.its.ac.id/informatika/wp-content/themes/DepartmentITS/assets/img/icons/logo-facebook.png"/>
										</a>
									</li>
								</ul>
							</div>
						</Col>
						<Col span={4}>
							<div class="footer-top-content border-left-white">
								<ul class="sosmed">
									<img src={logo} alt="Logo" className={"hehe5"}/>
								</ul>
							</div>
						</Col>
					</Row>
					<Row className={"wrapper-footer"}>
						<Col span={24} className={"copyright"}>
							Copyright © 2019 Institut Teknologi Sepuluh Nopember - Departemen Informatika - Human Computer Interaction - Ichiraku Ramen
						</Col>
					</Row>
				</Layout.Footer>
			</div>
		);
	}
}
export default App;
